<template>
  <div class="sidebar">
    <div class="sidebar-sticky">
      <ul class="nav flex-column">
        <li class="nav-item">
          <b-link
            class="nav-link font-weight-bolder text-aegis-dk"
            :to="{ name: 'home' }"
            exact
          >
            AEGIS Home
          </b-link>
        </li>
      </ul>
      
      <hr>
      <ul class="nav flex-column">
        <li class="nav-item">
          <b-dropdown-header class="sidebar-heading pl-0 text-aegis-dk">
            <i class="fas fa-chart-bar"></i>
            MAIN
          </b-dropdown-header>
        </li>
        <li class="nav-item">
          <b-link class="nav-link" :to="{ name: 'dashboard' }" exact>
            Dashboard
          </b-link>
        </li>
        <li class="nav-item" v-if="inMyGroups(['Social Science Manager'])">
          <b-link class="nav-link" :to="{ name: 'metrics-social-science-manager' }" exact>
            Social Science Dashboard
          </b-link>
        </li>

        <li class="nav-item" v-if="inMyGroups(['Program PI', 'ND Scientific Director'])">
          <b-link class="nav-link" :to="{ name: 'consortium-report' }" exact>
            Consortium Report
          </b-link>
        </li>

         <li class="nav-item" v-if="inMyGroups(['Program PI', 'ND Scientific Director', 'fhiClinical'])">
          <b-link class="nav-link" :to="{ name: 'subjects-withdrawn-report' }" exact>
            Subjects Withdrawn Report
          </b-link>
        </li>

         <li class="nav-item" v-if="inMyGroups(['Program PI', 'ND Scientific Director', 'DSMB', 'fhiClinical'])">
          <b-link class="nav-link" :to="{ name: 'ae-sae-report' }" exact>
            AE/SAE - Subject Data - Report/Download
          </b-link>
        </li>

        <li class="nav-item" v-if="inMyGroups(['Program PI', 'ND Scientific Director', 'DSMB'])">
          <b-link class="nav-link" :to="{ name: 'ae-sae-community-report' }" exact>
            AE/SAE - Community Data - Report/Download
          </b-link>
        </li>

        <li class="nav-item" v-if="inMyGroups(['DSMB', 'Study Statistician', 'fhiClinical'])">
          <b-link class="nav-link" :to="{ name: 'analysis' }" exact>
            Analysis
          </b-link>
        </li>

        <li class="nav-item" v-if="inMyGroups(['Site PI', 'Program PI'])">
          <b-link class="nav-link" :to="{ name: 'hobo-data' }" exact>
            Hobo Data
          </b-link>
        </li>

        <li class="nav-item" v-if="inMyGroups(['Site PI', 'Program PI', 'fhiClinical', 'Data Manager', 'Social Science Manager', 'SAE Report Uploader'])">
          <b-link class="nav-link" :to="{ name: 'uploads-upload' }" exact>
            Uploads
          </b-link>
        </li>

        <li class="nav-item" v-if="STUDY == 'kenya'">
          <b-link
            class="nav-link"
            :to="{ name: 'baseline-compounds' }"
            exact
            v-if="inMyGroups(['Data Manager', 'Site PI', 'Social Science Lead'])"
          >
            Cohort 2 Compounds
          </b-link>
        </li>     

        <li class="nav-item" v-if="inMyGroups(['Program PI', 'fhiClinical', 'Site PI'])">
          <b-link class="nav-link" :to="{ name: 'query-request' }" exact>
            Query Requests
          </b-link>
        </li>   
        <li class="nav-item" v-if="inMyGroups(['Site PI', 'Program PI'])">
          <b-link class="nav-link" :to="{ name: 'query-builder' }" exact>
            Query Builder
          </b-link>
        </li>
      </ul>

      <hr v-if="inMyGroups(['Data Manager', 'Ento Lead', 'Epi Lead', 'DSMB', 'fhiClinical', 'SCJ', 'Program PI', 'ND Scientific Director', 'Site PI', 'Notify SAE Acknowledgement'])" />
      <ul class="nav flex-column" v-if="inMyGroups(['Data Manager', 'Ento Lead', 'Epi Lead', 'DSMB', 'fhiClinical', 'SCJ', 'Program PI', 'ND Scientific Director', 'Site PI', 'Notify SAE Acknowledgement'])">
        <li class="nav-item">
          <b-dropdown-header class="sidebar-heading pl-0 text-aegis-dk">
            <i class="fas fa-table"></i>
            Review Required
          </b-dropdown-header>
        </li>

        <!-- SAE/AE -->
      <li class="nav-item" v-if="inMyGroups(['Data Manager', 'Epi Lead', 'DSMB', 'fhiClinical', 'SCJ', 'Program PI', 'ND Scientific Director', 'Site PI', 'Notify SAE Acknowledgement'])">
          <b-link class="nav-link" :to="{ name: 'serious-adverse-events' }">
            Serious Adverse Events
            <b-badge
              v-if="seriousadverseeventscount > 0"
              variant="danger"
              class="mr-1"
              >{{ seriousadverseeventscount }}</b-badge
            >
            <b-badge
              v-if="otherseriousadverseeventscount > 0"
              variant="warning"
              >{{ otherseriousadverseeventscount }}</b-badge
            >
          </b-link>
        </li>
        
      <!-- Subject Final Status -->
        <li class="nav-item" v-if="inMyGroups(['Data Manager', 'Epi Lead', 'Site PI', 'Program PI', 'fhiClinical'])">
          <b-link class="nav-link" :to="{ name: 'subject-final-status' }">
            Subject Final Status Requests
            <b-badge v-if="finalstatuscount > 0" variant="danger" style="margin-right: 5px;">{{
              finalstatuscount
            }}</b-badge>
             <b-badge v-if="finalstatuscompleted > 0 & inMyGroups(['Program PI'])" variant="danger">{{
              finalstatuscompleted
            }}</b-badge>
          </b-link>
        </li>
      
      <!-- Structure Final Status -->
        <li class="nav-item" v-if="inMyGroups(['Data Manager', 'Epi Lead', 'Site PI', 'Program PI'])">
          <b-link class="nav-link" :to="{ name: 'structure-withdrawal' }">
            Structure Final Status Requests
            <b-badge v-if="structurefinalstatuscount > 0" variant="danger" style="margin-right: 5px;">{{
              structurefinalstatuscount
            }}</b-badge>
             <b-badge v-if="structurefinalstatuscompleted > 0 & inMyGroups(['Program PI'])" variant="danger">{{
              structurefinalstatuscompleted
            }}</b-badge>
          </b-link>
        </li>

      <!-- Microscopy Review -->
        <li class="nav-item" v-if="inMyGroups(['Data Manager', 'Site PI'])">
          <b-link class="nav-link" :to="{ name: 'microscopy-review-list' }">
            Microscopy Quality Control Review
            <b-badge v-if="microscopy_qc_count > 0" variant="danger">{{
              microscopy_qc_count
            }}</b-badge>
          </b-link>
        </li>
      
       <!-- Microscopy Review -->
        <li class="nav-item" v-if="inMyGroups(['Data Manager', 'Site PI'])">
          <b-link class="nav-link" :to="{ name: 'supervisor-help' }">
            Supervisor Help Requests
            <b-badge v-if="supervisor_requests > 0" variant="danger">{{
              supervisor_requests
            }}</b-badge>
          </b-link>
        </li>

      <!-- New Compounds -->
        <li class="nav-item" v-if="inMyGroups(['Data Manager', 'Site PI'])">
          <b-link class="nav-link" :to="{ name: 'new-compounds' }">
            New Compounds
            <b-badge v-if="new_compound_count > 0" variant="danger">{{
              new_compound_count
            }}</b-badge>
          </b-link>
        </li>

      <!-- Incomplete Visits -->
        <li class="nav-item" v-if="inMyGroups(['Data Manager', 'Epi Lead', 'Site PI'])">
          <b-link class="nav-link" :to="{ name: 'incomplete-visits' }">
            Incomplete Visits
            <b-badge v-if="incomplete_visits > 0" variant="danger">{{
              incomplete_visits
            }}</b-badge>
          </b-link>
        </li>

      <!-- Adverse Events -->
      <li class="nav-item" v-if="inMyGroups(['Data Manager', 'Epi Lead', 'DSMB', 'fhiClinical', 'SCJ', 'Program PI', 'ND Scientific Director', 'Site PI'])">
          <b-link class="nav-link" :to="{ name: 'adverse-events' }">
            Adverse Events
            <b-badge v-if="adverseeventscount > 0" variant="danger">{{
              adverseeventscount
            }}</b-badge>
          </b-link>
        </li>

      <!-- Subjects Referred -->
        <li class="nav-item" v-if="inMyGroups(['Data Manager', 'Epi Lead', 'Site PI'])">
          <b-link class="nav-link" :to="{ name: 'subjects-referred' }">
            Subjects Referred To Clinic
            <b-badge v-if="subjectsreferredcount > 0" variant="danger">{{
              subjectsreferredcount
            }}</b-badge>
          </b-link>
        </li>

      <!-- Subjects Moving -->
        <li class="nav-item" v-if="inMyGroups(['Data Manager', 'Epi Lead', 'Site PI'])">
          <b-link class="nav-link" :to="{ name: 'moving-subjects' }">
            Subjects Moving
          </b-link>
        </li>

      <!-- Form Date Errors -->
        <li class="nav-item" v-if="user.is_superuser || inMyGroups(['Data Manager'])">
          <b-link class="nav-link" :to="{ name: 'form-date-errors' }">
            Form Date Errors
            <b-badge v-if="formdateerrorcount > 0" variant="danger">{{
              formdateerrorcount
            }}</b-badge>
          </b-link>
        </li>

      <!-- Cluster Form Submission Map -->
        <li class="nav-item" v-if="inMyGroups(['Data Manager', 'Site PI'])">
          <b-link class="nav-link" :to="{ name: 'cluster-form-submissions' }">
            Form Submission Map
            <!-- <b-badge v-if="formdateerrorcount > 0" variant="danger">{{
              formdateerrorcount
            }}</b-badge> -->
          </b-link>
        </li>

        <li class="nav-item" v-if="inMyGroups(['Data Manager', 'Epi Lead', 'Site PI'])">
          <b-link class="nav-link" :to="{ name: 'microscopy-treatment-table' }">
            Treatment After Microscopy
          </b-link>
        </li>

        <li class="nav-item" v-if="inMyGroups(['Data Manager', 'Epi Lead', 'Site PI', 'Malaria Not Treated'])">
          <b-link class="nav-link" :to="{ name: 'overdue-treatment-table' }">
            Overdue Malaria Treatment
            <b-badge v-if="overduetreatmentcount > 0" variant="danger">{{
              overduetreatmentcount
            }}</b-badge>
          </b-link>
        </li>

        <li class="nav-item" v-if="STUDY=='mali'">
          <b-link class="nav-link" :to="{ name: 'ten-day-open-aesae-table' }">
            Open AE/SAE > 10 Days
            <b-badge
              v-if="tendayaesaecount > 0"
              variant="warning"
              class="mr-1"
              >{{ tendayaesaecount }}
            </b-badge>
          </b-link>
        </li>
      </ul>

      <hr v-if="inMyGroups(['Ento Data Entry Clerk', 'Data Manager', 'Ento Lead', 'Site PI', 'fhiClinical'])">
      <ul class="nav flex-column" v-if="inMyGroups(['Ento Data Entry Clerk', 'Data Manager', 'Ento Lead', 'Site PI', 'fhiClinical'])">
        <li class="nav-item">
          <b-dropdown-header class="sidebar-heading pl-0 text-aegis-dk">
            <i class="fas fa-tasks"></i>
            Ento Data Entry
          </b-dropdown-header>
        </li>
        <li class="nav-item" v-if="STUDY=='mali'">
          <b-link class="nav-link" :to="{ name: 'collection-code-lookup' }" exact>
            Collection Code Lookup
          </b-link>
        </li>
        <li class="nav-item" v-else>
          <b-link class="nav-link" :to="{ name: 'new-collection' }" exact>
            Process New Collection
          </b-link>
        </li>
        <!-- <li class="nav-item">
          <b-link class="nav-link" :to="{ name: 'ento-date-range' }" exact>
            Date Range
          </b-link>
        </li> -->
        <li class="nav-item" v-if="STUDY=='mali'">
          <b-link
            class="nav-link"
            :to="{ name: 'mosquito-data-entry', query: { tabIndex: 0 } }"
            exact
          >
            Mosquito Data Entry
          </b-link>
        </li>
        <li class="nav-item" v-else>
          <b-link
            class="nav-link"
            :to="{ name: 'anoph-data', query: { tabIndex: 0 } }"
            exact
          >
            Anoph Individual
          </b-link>
        </li>
        <li class="nav-item">
          <b-link
            class="nav-link"
            :to="{ name: 'anoph-data', query: { tabIndex: 1 } }"
            exact
          >
            Males
          </b-link>
        </li>
        <li class="nav-item">
          <b-link
            class="nav-link"
            :to="{ name: 'anoph-data', query: { tabIndex: 2 } }"
            exact
          >
            Culex
          </b-link>
        </li>

        <!-- <li class="nav-item">
          <b-link class="nav-link" :to="{ name: 'other-species-data' }" exact>
            Other Species
          </b-link>
        </li> -->

        <li class="nav-item">
          <b-link
            class="nav-link"
            :to="{ name: 'ento-date-range' }"
            exact
          >
            Species ID
          </b-link>
        </li>
        <li class="nav-item">
          <b-link
            class="nav-link"
            :to="{ name: 'ento-date-range-elisa-result'}"
            exact
          >
            ELISA Result
          </b-link>
        </li>
        <li class="nav-item">
          <b-link class="nav-link" :to="{ name: 'ento-table' }" exact>
            Ento Table
          </b-link>
        </li>
      </ul>

      <hr v-if="inMyGroups(['Data Manager', 'Epi Lead', 'Site PI', 'Program PI', 'fhiClinical'])">
      <ul class="nav flex-column" v-if="inMyGroups(['Data Manager', 'Epi Lead', 'Site PI', 'Program PI', 'fhiClinical'])">
        <li class="nav-item">
          <b-dropdown-header class="sidebar-heading pl-0 text-aegis-dk">
            <i class="fas fa-table"></i>
            Epi Data
          </b-dropdown-header>
        </li>

        <li class="nav-item" v-if="inMyGroups(['Data Manager', 'Epi Lead', 'Site PI', 'fhiClinical'])">
          <b-link class="nav-link" :to="{ name: 'random-subjects' }">
            Random Subject QC
          </b-link>
        </li>

         <!-- <li class="nav-item" v-if="inMyGroups(['Data Manager'])">
          <b-link class="nav-link" :to="{ name: 'subjects-pregnant' }">
            Subjects Pregnant
            <b-badge v-if="subjects_past_due > 0" variant="danger">{{
              subjects_past_due
            }}</b-badge>
          </b-link>
        </li> -->

        <li class="nav-item" v-if="inMyGroups(['Epi Lead', 'Data Manager', 'Social Science Manager'])">
          <b-link class="nav-link" :to="{ name: 'subject' }">
            Subject History
          </b-link>
        </li>

        <li class="nav-item">
          <b-link class="nav-link" :to="{ name: 'subject-microscopy-template', params: { view: 'summary'} }">
            Subject Microscopy Summary
          </b-link>
        </li>

        <li class="nav-item">
          <b-link class="nav-link" :to="{ name: 'metrics-subject-followup', params: { view: 'summary'} }">
            Subject Followup Completion
          </b-link>
        </li>

        <!-- <li class="nav-item">
          <b-link
            class="nav-link"
            :to="{ name: 'generic', query: { view: 'CaseSubjects' } }"
            exact
            v-if="inMyGroups(['Program PI'])"
          >
            Subject Cases
          </b-link>
        </li> -->

        <!-- <li class="nav-item">
          <b-link
            class="nav-link"
            :to="{ name: 'generic', query: { view: 'SubjectFollowupForm' } }"
            exact
            v-if="inMyGroups(['Program PI'])"
          >
            Subject Followup
          </b-link>
        </li> -->

        <!-- <li class="nav-item" v-if="inMyGroups(['Program PI'])">
          <b-link
            class="nav-link"
            :to="{ name: 'subjects-enrolled'}"
            exact
          >
            Subject Enrollment (In Progress)
          </b-link>
        </li> -->

        <li class="nav-item" v-if="inMyGroups(['Program PI', 'Data Manager', 'fhiClinical'])">
          <b-link
            class="nav-link"
            :to="{ name: 'metrics-subject-enrollment'}"
            exact
          >
            Subject Enrollment Details
          </b-link>
        </li>

        <li class="nav-item" v-if="inMyGroups(['Data Manager', 'Ento Lead', 'Site PI'])">
          <b-link
            class="nav-link"
            :to="{ name: 'structures-not-listed'}"
            exact
          >
            Missing Structures
          </b-link>
        </li>
        <li class="nav-item" v-if="inMyGroups(['Data Manager', 'Ento Lead', 'Site PI'])">
          <b-link
            class="nav-link"
            :to="{ name: 'structure-changes'}"
            exact
          >
            Structure Changes
          </b-link>
        </li>
        <li class="nav-item" v-if="STUDY=='kenya'">
          <b-link
            class="nav-link"
            :to="{ name: 'blood-slide-location' }"
            exact
          >
            Blood Slide Location
          </b-link>
        </li>
      </ul>

      <hr v-if="inMyGroups(['Data Manager', 'Ento Lead', 'Site PI', 'Social Science Lead', 'fhiClinical'])">
      <ul class="nav flex-column" v-if="inMyGroups(['Data Manager', 'Ento Lead', 'Site PI', 'Social Science Lead', 'fhiClinical'])">
        <li class="nav-item">
          <b-dropdown-header class="sidebar-heading pl-0 text-aegis-dk">
            <i class="fas fa-table"></i>
            Ento Data
          </b-dropdown-header>
        </li>

        <!-- <li class="nav-item">
          <b-link
            class="nav-link"
            :to="{ name: 'generic', query: { view: 'CaseCompound' } }"
            exact
            v-if="inMyGroups(['Program PI'])"
          >
            Compound Cases
          </b-link>
        </li> -->

        <li class="nav-item">
          <b-link
            class="nav-link"
            :to="{ name: 'light-traps' }"
            exact
            v-if="inMyGroups(['Data Manager', 'Ento Lead', 'Site PI'])"
          >
            Light Trap Schedules
          </b-link>
        </li>
        <li class="nav-item">
          <b-link
            class="nav-link"
            :to="{ name: 'hlc' }"
            exact
            v-if="inMyGroups(['Data Manager', 'Ento Lead', 'Site PI', 'Social Science Lead'])"
          >
            HLC
          </b-link>
        </li>
      </ul>

      <hr v-if="inMyGroups(['Program PI'])">
      <ul class="nav flex-column" v-if="inMyGroups(['Data Manager', 'Program PI'])">
        <li class="nav-item">
          <b-dropdown-header class="sidebar-heading pl-0 text-aegis-dk">
            <i class="fas fa-table"></i>
            Product Data
          </b-dropdown-header>
        </li>
        <li class="nav-item">
          <b-link
            class="nav-link"
            :to="{ name: 'product-replacements' }"
            exact
            v-if="inMyGroups(['Data Manager', 'Program PI'])"
          >
            Product Replacements
          </b-link>
        </li>
        <li class="nav-item">
          <b-link
            class="nav-link"
            :to="{ name: 'product-replacement-summary' }"
            exact
            v-if="inMyGroups(['Data Manager', 'Program PI'])"
          >
            Product Replacement Summary
          </b-link>
        </li>
        <!-- <li class="nav-item" v-if="inMyGroups(['Data Manager', 'Epi Lead', 'DSMB', 'fhiClinical', 'SCJ', 'Program PI', 'ND Scientific Director', 'Site PI', 'Notify SAE Acknowledgement'])"> -->
        <li class="nav-item" v-if="STUDY=='mali'">
          <b-link class="nav-link" :to="{ name: 'late-product-replacement' }">
            Late Product Replacement
            <b-badge
              v-if="missedproductscount > 0"
              variant="warning"
              class="mr-1"
            >{{ missedproductscount }}</b-badge>
          </b-link>
        </li>
      </ul>

      <hr v-if="inMyGroups(['Social Science Manager', 'Program PI'])">
      <ul class="nav flex-column" v-if="inMyGroups(['Social Science Manager', 'Program PI'])">
        <li class="nav-item">
          <b-dropdown-header class="sidebar-heading pl-0 text-aegis-dk">
            <i class="fas fa-table"></i>
            Social Sciences
          </b-dropdown-header>
        </li>

        <li class="nav-item">
          <b-link
            class="nav-link"
            :to="{ name: 'generic', query: { view: 'RetailAuditListingForm' } }"
            exact
          >
            Retail Audit Data
          </b-link>
        </li>
        <li class="nav-item">
          <b-link
            class="nav-link"
            :to="{ name: 'tips-data' }"
            exact
          >
            TIPs Data
          </b-link>
        </li>

        <!-- <li class="nav-item">
          <b-link class="nav-link" :to="{ name: 'subject-microscopy-template', params: { view: 'details'} }">
            Subject Microscopy Details
          </b-link>
        </li> -->

        
      </ul>
      <!-- <ul class="nav flex-column" v-if="inMyGroups(['Program PI'])">
                <li class="nav-item">
                    <b-link class="nav-link" :to="{name: 'subject-microscopy-upload'}">
                        Subject Microscopy CSV Upload
                    </b-link>
                </li>
            </ul>
            <ul class="nav flex-column" v-if="inMyGroups(['Program PI'])">
                <li class="nav-item">
                    <b-link class="nav-link" :to="{name: 'subject-microscopy-table'}">
                        Subject Microscopy CSV Table
                    </b-link>
                </li>
            </ul> -->
      
      <!-- <ul class="nav flex-column" v-if="inMyGroups(['Program PI'])">
        <li class="nav-item">
          <b-link class="nav-link" :to="{ name: 'subjects-referred' }">
            Subjects Referred To Clinic
            <b-badge v-if="subjectsreferredcount > 0" variant="danger">{{
              subjectsreferredcount
            }}</b-badge>
          </b-link>
        </li>
      </ul>
      <ul class="nav flex-column" v-if="inMyGroups(['Program PI'])">
        <li class="nav-item">
          <b-link
            class="nav-link"
            :to="{ name: 'subjects-referred-dismissed' }"
          >
            Dismissed Subjects Referred To Clinic
          </b-link>
        </li>
      </ul> -->
      <ul class="nav flex-column" v-if="user.is_superuser">
        <hr />
        <li class="nav-item">
          <b-dropdown-header class="sidebar-heading pl-0 text-aegis-dk">
            <i class="fas fa-users"></i>
            Admin
          </b-dropdown-header>
        </li>
        <li class="nav-item">
          <b-link class="nav-link" :to="{ name: 'users' }">
            Users
          </b-link>
        </li>
        <li class="nav-item">
          <b-link
            class="nav-link"
            :to="{ name: 'generic', query: { view: 'CommcareExportRuns' } }"
            exact
          >
            Export Runs
          </b-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  data() {
    return {
      drawer: true
    };
  },
  mounted() {
    this.getSubjectFinalCount().then(response => {
      this.setSubjectFinalCount(response.data);
    });

    this.getSubjectFinalCompletedCount().then(response => {
      this.setSubjectFinalCompletedCount(response.data);
    });

    this.getStructureFinalCount().then(response => {
      this.setStructureFinalCount(response.data);
    });

    this.getStructureFinalCompletedCount().then(response => {
      this.setStructureFinalCompletedCount(response.data);
    });

    this.getSubjectsReferredCount().then(response => {
      this.setSubjectsReferredCount(response.data);
    });

    this.getFormDateErrorCount().then(response => {
      this.setFormDateErrorCount(response.data);
    });

    this.getAdverseEventsCount().then(response => {
      this.setAdverseEventsCount(response.data);
    });

    this.getSeriousAdverseEventsCount().then(response => {
      this.setSeriousAdverseEventsCount(response.data);
    });

    this.getTenDayAESAECount().then(response => {
      this.setTenDayAESAECount(response.data);
    });

    this.getMissedProductCount().then(response => {
      this.setMissedProductsCount(response.data);
    });    
    
    this.getOverdueTreatmentCount().then(response => {
      this.setOverdueTreatmentCount(response.data);
    });

    this.getMicroscopyReviewCount().then(response => {
      this.setMicroscopyReviewCount(response.data);
    });

    this.getSupervisorRequestsCount().then(response => {
      this.setSupervisorRequestsCount(response.data);
    });

     this.getNewCompoundCount().then(response => {
      this.setNewCompoundCount(response.data);
    });

    this.getPregnantPastDueCount().then(response => {
      this.setPregnantPastDueCount(response.data);
    });

    this.getIncompleteVisitsCount().then(response => {
      this.setIncompleteVisitsCount(response.data);
    });

    // Putting it here because this would only be executed if they are logged in.
    let recaptchaScript = document.createElement("script");
    recaptchaScript.setAttribute("data-jsd-embedded", "");
    recaptchaScript.setAttribute("data-key", "71f002bb-1917-4e79-a426-3806143d541e");
    recaptchaScript.setAttribute("data-base-url", "https://jsd-widget.atlassian.com");
    recaptchaScript.setAttribute("src", "https://jsd-widget.atlassian.com/assets/embed.js");
    document.body.appendChild(recaptchaScript);

    setTimeout(() => {
        var DOMContentLoaded_event = document.createEvent('Event');
        DOMContentLoaded_event.initEvent('DOMContentLoaded', true, true);
        document.dispatchEvent(DOMContentLoaded_event);
    }, 3000);
  },
  computed: {
    ...mapState("user", ["user", "myGroups"]),
    ...mapGetters("user", ['inMyGroups']),
    ...mapState("subjectfinalstatus", { finalstatuscount: "count" }),
    ...mapState("subjects_past_due", { subjects_past_due: "count" }),
    ...mapState("incomplete_visits", { incomplete_visits: "count" }),
    ...mapState("subjectfinalstatuscompleted", {
      finalstatuscompleted: "count"
    }),

    ...mapState("structurefinalstatus", { structurefinalstatuscount: "count" }),
    ...mapState("structurefinalstatuscompleted", {
      structurefinalstatuscompleted: "count"
    }),
    ...mapState("subjectsreferred", { subjectsreferredcount: "count" }),
    ...mapState("formdateerrors", { formdateerrorcount: "count" }),
    ...mapState("overduetreatment", { overduetreatmentcount: "count" }),
    ...mapState("microscopy_qc_count", { microscopy_qc_count: "count" }),
    ...mapState("supervisor_requests", { supervisor_requests: "count" }),
    ...mapState("new_compound_count", { new_compound_count: "count" }),
    ...mapState("adverseevents", { adverseeventscount: "adverse_count" }),
    ...mapState("adverseevents", {
      seriousadverseeventscount: "serious_adverse_count"
    }),
    ...mapState("adverseevents", {
      otherseriousadverseeventscount: "other_serious_adverse_count"
    }),
    ...mapState("adverseevents", {
      tendayaesaecount: "ten_day_aesae_count"
    }),
    ...mapState("products", {
      missedproductscount: "missed_product_count"
    })
  },
  methods: {
    ...mapActions("subjectfinalstatus", [
      "getSubjectFinalCount",
      "setSubjectFinalCount"
    ]),
    ...mapActions("structurefinalstatus", [
      "getStructureFinalCount",
      "setStructureFinalCount"
    ]),
    ...mapActions("structurefinalstatuscompleted", [
      "getStructureFinalCompletedCount",
      "setStructureFinalCompletedCount"
    ]),

    ...mapActions("subjects_past_due", [
      "getPregnantPastDueCount",
      "setPregnantPastDueCount"
    ]),

    ...mapActions("incomplete_visits", [
      "getIncompleteVisitsCount",
      "setIncompleteVisitsCount"
    ]),

    ...mapActions("subjectfinalstatuscompleted", [
      "getSubjectFinalCompletedCount",
      "setSubjectFinalCompletedCount"
    ]),

    ...mapActions("subjectsreferred", [
      "getSubjectsReferredCount",
      "setSubjectsReferredCount"
    ]),

    ...mapActions("formdateerrors", [
      "getFormDateErrorCount",
      "setFormDateErrorCount"
    ]),

    ...mapActions("microscopy_qc_count", [
      "getMicroscopyReviewCount",
      "setMicroscopyReviewCount"
    ]),

    ...mapActions("overduetreatment", [
      "getOverdueTreatmentCount",
      "setOverdueTreatmentCount"
    ]),

    ...mapActions("supervisor_requests", [
      "getSupervisorRequestsCount",
      "setSupervisorRequestsCount"
    ]),

    ...mapActions("new_compound_count", [
      "getNewCompoundCount",
      "setNewCompoundCount"
    ]),

    ...mapActions("adverseevents", [
      "getAdverseEventsCount",
      "setAdverseEventsCount",
      "getSeriousAdverseEventsCount",
      "setSeriousAdverseEventsCount",
      "getTenDayAESAECount",
      "setTenDayAESAECount"
    ]),
    ...mapActions("products", [
      "getMissedProductCount",
      "setMissedProductsCount"
    ]),

    ...mapActions(["setBaseComponent", "clearAuthorizationToken"]),
    ...mapActions("user", ["setUser"]),
    goTo(route) {
      this.$router.push(route);
    },
    toggle: function() {
      this.drawer = !this.drawer;
    },
    logout: function() {
      this.clearAuthorizationToken();
      this.setUser({});

      this.$notify({
        text: "You have been logged out",
        duration: 10000,
        type: "warn"
      });

      this.$router.push({
        name: "home"
      });
    }
  }
};
</script>

<style>
.sidebar {
  background-color: white;
  box-shadow: inset -1px 0 0 rgba(0, 0, 0, 0.1);
  padding-top: 15px;
  /* height: calc(100vh - 70px); */
  height: 100%;
  /* overflow-y: scroll; */
}
.sidebar .nav-link {
  font-size: 0.9rem;
  font-weight: 400;
  color: #666;
  line-height: 1.3;
  outline: 0;
  padding-left: 2.5rem;
}

.sidebar .nav-link .feather {
  margin-right: 4px;
  color: #999;
}

.sidebar .nav-link.router-link-active {
  color: #333; /* #007bff; */
  font-weight: 500;
  background: #e1eef2;
}

.sidebar .nav-link:hover .feather,
.sidebar .nav-link.active .feather {
  color: inherit;
}

.sidebar-heading {
  font-size: 0.9rem;
  text-transform: uppercase;
  font-weight: 600;
}
</style>
